import React from "react";

import page_nav_icon_left from "../../../assets/images/page_nav_icon_left.svg";
import page_nav_icon_right from "../../../assets/images/page_nav_icon_right.svg";
import "./Pagination.css";

const Pagination = ({
  totalItems,
  currentPage,
  itemsPerPage,
  itemsPerPageOptions = [10, 30, 50, 100],
  onPageChange,
  onItemsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const getDisplayedPageNumbers = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push("...");
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);
      for (let i = startPage; i <= endPage; i++) pages.push(i);
      if (currentPage < totalPages - 2) pages.push("...");
      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <div className="pagination-container">
      <div className="items-per-page">
        <span>Show</span>
        <select
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
        >
          {itemsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
          >
            <img
              src={page_nav_icon_left}
              alt="Go left"
              style={{
                objectFit: "none",
                height: "40px",
                width: "35px",
              }}
            />
          </button>
          {getDisplayedPageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => page !== "..." && onPageChange(page)}
              className={currentPage === page ? "active" : ""}
              disabled={page === "..."}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
          >
            <img
              src={page_nav_icon_right}
              alt="Go right"
              style={{
                objectFit: "none",
                height: "40px",
                width: "35px",
              }}
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default Pagination;
